import React from 'react';
import styles from '../styles.module.css';
import { brandBg, brandColors } from '@/functions/formats';
import AppImage from '@/components/common/AppImage';

export default function BrandLogo({
  name,
  index,
  className = '',
  random = false,
  image,
}: {
  name?: string;
  index: number;
  className?: string;
  random?: boolean;
  image?: { id?: number; name?: string };
}) {
  const nameHash = name
    ?.split('')
    .reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  const randomIndex = (nameHash ?? 0) % (brandColors?.length || 1);
  const generateAbbr = (name?: string) => {
    const nameArray = name?.trim().split(/\s+/);

    let result = nameArray?.map((d) => d?.slice(0, 1)?.toUpperCase());
    return result?.join('\u200C');
  };

  if (image?.name) {
    return (
      <div className={`${styles.logo} ${className}`}>
        <AppImage
          src={image.name}
          alt={name ? `لوگو ${name}` : 'لوگوی برند'}
          width={64}
          height={64}
          className={styles.logoImage}
          containerclassName={styles.logoImageContainer}
        />
      </div>
    );
  }

  return (
    <div
      className={`${styles.logo} ${className}`}
      style={{ background: !random ? brandBg(index) : brandBg(randomIndex) }}
    >
      <div className={styles.logoPattern} />
      {name && <span className={styles.initials}>{generateAbbr(name)}</span>}
    </div>
  );
}
